import React, { FunctionComponent } from 'react';
import cn from 'classnames';
import FormGroup, { FormGroupProps } from '../FormGroup/FormGroup';
import { TextArea, TextAreaProps } from '../../TextArea';
import styles from './FormTextArea.scss';

export type FormTextAreaProps = TextAreaProps & FormGroupProps;

const FormTextArea: FunctionComponent<FormTextAreaProps> = ({
  value,
  onChange,
  onBlur,
  onFocus,
  id,
  ariaLabel,
  placeholder,
  maxLength,
  resizeable,
  showCharacterCount,
  ...props
}) => {
  const isErrored = (props.touched ?? true) && (props.error ?? false);

  return (
    <FormGroup {...props}>
      <TextArea
        className={cn(
          'jg-form-control',
          isErrored ? 'jg-form-control--error' : '',
          styles.formTextArea,
        )}
        ariaLabel={ariaLabel}
        id={id}
        name={props.name}
        placeholder={placeholder}
        value={value}
        maxLength={maxLength}
        resizeable={resizeable}
        showCharacterCount={showCharacterCount}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        minRows={props.minRows}
      />
    </FormGroup>
  );
};

export default FormTextArea;
